import { render, staticRenderFns } from "./Selective.vue?vue&type=template&id=2ed2fb15&scoped=true&"
import script from "./Selective.vue?vue&type=script&lang=js&"
export * from "./Selective.vue?vue&type=script&lang=js&"
import style0 from "./Selective.vue?vue&type=style&index=0&id=2ed2fb15&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed2fb15",
  null
  
)

export default component.exports